import { useEffect, useState } from "react";
import AudiosService from "../Services/Audios";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import { Breadcrumbs } from "./E-BooksComponent";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import imgpause from "../assets/audioPlayer/img/yellowplay.svg";
import imgdownload from "../Images/downloadpravachan.svg";
import ListPagination from "../Components/ListPagination";
import Loader from "./Loader";
import { LogInModel } from "./LoginModel";
import i18n from "../i18n";
import "../Styles/Audios.css";
import "../Styles/Sidebar.css";
import StarIcon from '@mui/icons-material/Star';
import { SideBar } from "./SubMenu";
import { FilterIcon, SortIcon } from "./Icon";
import Reset from "../Images/reset.png";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/hi";
import dayjs, { Dayjs } from "dayjs";

const DailySatsangPage = () => {
    const isHindi = i18n.language === "hi";
    const hiLocaleText: any = {
        previousMonth: 'पिछला महीना',
        nextMonth: 'अगला महीना',
        openPreviousView: 'पिछला दृश्य खोलें',
        openNextView: 'अगला दृश्य खोलें',
        cancelButtonLabel: 'रद्द करें',
        clearButtonLabel: 'साफ़ करें',
        okButtonLabel: 'ठीक है',
        todayButtonLabel: 'आज',
        datePickerToolbarTitle: 'तिथि चुनें',
        start: 'प्रारंभ',
        end: 'समाप्त',
        fieldClearLabel: 'मान साफ़ करें',
        fieldYearPlaceholder: () => '   ',
        fieldMonthPlaceholder: () => '  ',
        fieldDayPlaceholder: () => '  ',
    };
    const UserIdentity = localStorage.getItem("UserId") as any;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [podcastData, setPodcastData] = useState<any[] | undefined | any>(undefined);
    const [logIn, setLogIn] = useState<boolean>(false);
    const [ItemtoPlay, setItemtoPlay] = useState<any>(null);
    const [SortValue, setSortValue] = useState("3");
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);

    const closeModal = () => {
        setLogIn(false);
    };

    function ResetData() {
        setStartDate(null);
        setEndDate(null);
        setSortValue("3");
        setPagination({ ...pagination, pageNo: 0 });
        setRefresh(true);
    }

    const [refresh, setRefresh] = useState(false);
    const [pagination, setPagination] = useState({
        pageNo: 1,
        recordsPerPage: 12,
        totalRecords: 0,
    });

    var timestamp = new Date().getTime();
    const encoded = btoa(timestamp.toString());

    const [loading, setLoading] = useState(true);

    const handleLoginStateChange = (newState: any) => {
        if (newState === true && ItemtoPlay) {
            localStorage.setItem("type", "DailySatsang");
            const slugToUse = ItemtoPlay.audioslug || ItemtoPlay.description || "";
            console.log("slugToUse", slugToUse);
            navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                state: {
                    audioId: ItemtoPlay.audioId,
                    audioslug: slugToUse,
                    index: ItemtoPlay.index,
                    pageNum: ItemtoPlay.pageNum,
                },
            });
            setItemtoPlay(null); // Clear the item to play
        }
    };

    const downloadDailySatsang = (pravachanPath: any) => {
        const imageUrl = pravachanPath;
        const link = document.createElement('a');
        link.href = imageUrl; link.download = 'image.jpg';
        document.body.appendChild(link); link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        setRefresh(false);
        const fetchData = async () => {
            try {
                const response = await AudiosService.getDailySatsang(
                    "",
                    pagination.pageNo === 0
                        ? 0
                        : pagination.recordsPerPage * pagination.pageNo - 12,
                    pagination.recordsPerPage,
                    SortValue,
                    "",
                    "",
                    "",
                    0,
                    startDate ? startDate.format("YYYY-MM-DD") : "",
                    endDate ? endDate.format("YYYY-MM-DD") : ""
                )
                const res = await response;
                setPodcastData(res.result?.items);
                setPagination({
                    ...pagination,
                    totalRecords: res.result?.totalRecords,
                });
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [refresh, i18n.language, SortValue, startDate, endDate])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        document.documentElement.lang = i18n.language === "hi" ? "hi" : "en";
    }, [i18n.language]);


    const style: any = () => {
        return (
            <h1 style={{ fontWeight: 700, fontSize: "36px" }}>{t("daily_satsang_tr")}</h1>
        )
    }

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            localeText={isHindi ? hiLocaleText : undefined}
            adapterLocale={i18n.language === "hi" ? "hi" : "en"}
        >
        <div style={{ marginBottom: "20px" }}>

            <div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px", marginTop: "-60px" }}>
                <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px", backgroundColor: "rgb(255, 237, 188)" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: "20px",
                            flexWrap: "wrap",
                            padding: "28px 0 16px",
                        }}
                    >
                        <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                            <div style={{ padding: "8px 0" }}>
                                <h2 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700, marginTop: "70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                                    {t("daily_satsang_tr")}
                                </h2>
                                <div style={{ marginTop: "10px", fontSize: 19, fontWeight: 600, color: "rgb(45, 42, 41)" }}>
                                    <Link to="/" style={{ marginRight: "", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                                    <span style={{ margin: "0 6px" }}>/</span>
                                    <span>{t("daily_satsang_tr")}</span>
                                </div>
                            </div>
                        </div>

                        <div
                            style={{
                                width: "1px",
                                minHeight: "100px",
                                background: "#facc6f",
                                marginTop: "65px",
                            }}
                        />

                        <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                            <h1
                                style={{
                                    textAlign: "center",
                                    color: "rgb(228, 121, 7)",
                                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                                    fontWeight: 600,
                                    margin: 0,
                                    paddingTop: "30px",
                                    // marginb:"-10px",
                                }}
                            >
                                {t("Daily_Satsang_title_tr")}
                            </h1>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: "8px",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                                <svg
                                    width="26"
                                    height="18"
                                    viewBox="0 0 26 18"
                                    style={{ margin: "0 12px" }}
                                >
                                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                                </svg>
                                <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                            </div>

                            <p
                                style={{
                                    fontSize: 17,
                                    color: "#4a4036",
                                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                                    // margin: "25px 0 -10px",
                                    margin: "18px 0px 0px 0px",
                                    width: "100%",
                                    lineHeight: 1.75,
                                    whiteSpace: "normal",
                                    overflowWrap: "break-word",
                                    textAlign: "justify",
                                }}
                            >
                                {t("Daily_Satsang_description_tr")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ background: "rgb(255, 246, 225)" }}>
                <div className="containers">
                    {podcastData?.length >= 0 ?
                        <div className="row">

                            <div className="col-lg-3">
                                <div className="sidebar-container">
                                    <div>
                                        <div className="cardbackground filter-header">
                                            <FilterIcon /> <span className="boxheadtitle" style={{ color: "rgb(228, 121, 7)" }}>{t("Filter_tr")}</span>
                                            {(startDate !== null || endDate !== null || SortValue !== "3") && (
                                                <img
                                                    alt="reset"
                                                    src={Reset}
                                                    className="resetimg"
                                                    onClick={() => {
                                                        ResetData();
                                                    }}
                                                />
                                            )}
                                        </div>

                                        <div className="filter-options-container">
                                            <Accordion defaultExpanded elevation={0} className="filter-accordion">
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    className="filter-accordion-summary"
                                                    style={{
                                                        background: "#fffaec",
                                                        height: "0px",
                                                        minHeight: "25px",
                                                        marginTop: "15px",
                                                    }}
                                                >
                                                    <p className="filtertitle audio-list-title">
                                                        {t("Filter_tr_Date")}
                                                    </p>
                                                </AccordionSummary>

                                                <AccordionDetails className="filter-accordion-details">
                                                    <div>
                                                        <div className="filteryearmonth" style={{ marginTop: "15px" }}>
                                                            <div>
                                                                <span>{t("Start_Date_tr")}</span>
                                                            </div>
                                                            <div style={{ marginTop: "6px", width: "100%" }} className={isHindi ? "hindi-date-picker" : ""}>
                                                                <DatePicker
                                                                    value={startDate}
                                                                    onChange={(newValue) => setStartDate(newValue)}
                                                                    format={isHindi ? "DD / MM / YYYY" : "DD/MM/YYYY"}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            inputProps:{readOnly:true},
                                                                            onClick: (e) => {
                                                                               (e.currentTarget.querySelector("input") as HTMLInputElement)?.focus();
                                                                              },
                                                                            sx: {
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    borderRadius: "4px",
                                                                                    fontSize: "14px",
                                                                                    fontWeight: 600,
                                                                                    fontFamily: "Verdana, NalandaTim, Tunga",
                                                                                    height: "38px",
                                                                                    backgroundColor: "#fff",
                                                                                    overflow: "hidden",
                                                                                    "& fieldset": {
                                                                                        borderColor: "#ffc840",
                                                                                    },
                                                                                    "&:hover fieldset": {
                                                                                        borderColor: "#ffc840",
                                                                                    },
                                                                                    "&.Mui-focused fieldset": {
                                                                                        borderColor: "#ffc840",
                                                                                    },
                                                                                },
                                                                                "& .MuiInputLabel-root": {
                                                                                    fontSize: "14px",
                                                                                    color: "#54422d",
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    color: "#54422d",
                                                                                    fontSize: "14px",
                                                                                    fontWeight: 600,
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                },
                                                                            },
                                                                        },
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="filteryearmonth" style={{ marginTop: "15px" }}>
                                                            <div>
                                                                <span>{t("End_Date_tr")}</span>
                                                            </div>
                                                            <div style={{ marginTop: "6px", width: "100%" }} className={isHindi ? "hindi-date-picker" : ""}>
                                                                <DatePicker
                                                                    value={endDate}
                                                                    onChange={(newValue) => setEndDate(newValue)}
                                                                    format={isHindi ? "DD / MM / YYYY" : "DD/MM/YYYY"}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                               inputProps: {
                                                                                readOnly: true,
                                                                             },
                                                                            sx: {
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    borderRadius: "4px",
                                                                                    fontSize: "14px",
                                                                                    fontWeight: 600,
                                                                                    fontFamily: "Verdana, NalandaTim, Tunga",
                                                                                    height: "38px",
                                                                                    backgroundColor: "#fff",
                                                                                    overflow: "hidden",
                                                                                    "& fieldset": {
                                                                                        borderColor: "#ffc840",
                                                                                    },
                                                                                    "&:hover fieldset": {
                                                                                        borderColor: "#ffc840",
                                                                                    },
                                                                                    "&.Mui-focused fieldset": {
                                                                                        borderColor: "#ffc840",
                                                                                    },
                                                                                },
                                                                                "& .MuiInputLabel-root": {
                                                                                    fontSize: "14px",
                                                                                    color: "#54422d",
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    color: "#54422d",
                                                                                    fontSize: "14px",
                                                                                    fontWeight: 600,
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                },
                                                                            },
                                                                        },
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-9">
                                <div className="detailbg audios-list-container">
                                    <div className="sidebarmargin">
                                        <div className="align-items-center row" style={{ marginTop: "-18px" }}>
                                            <div className="col-6">
                                                <div className="filter1 total-records-container">
                                                    <span className="total-records-text">
                                                        <span style={{ color: "rgb(228, 121, 7)", fontFamily: "chanakyaUni", fontSize: "22px" }}>
                                                            {t("Total_Records_tr")}
                                                        </span> : {pagination.totalRecords}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="filter1 col-6 sort-container">
                                                <div className="filter1 sort-options" style={{ cursor: "pointer" }}>
                                                    <SortIcon /><span style={{ color: "rgb(228, 121, 7)", fontFamily: "chanakyaUni", fontSize: "22px" }}>{t("Sort_tr")}</span>
                                                    <select
                                                        value={SortValue}
                                                        onChange={(e) => setSortValue(e.target.value)}
                                                        className="sort-select"
                                                    >
                                                        <option value="0">{t("General_tr")}</option>
                                                        <option value="3">{t("Popular_tr")}</option>
                                                        <option value="2">{t("Latest_tr")}</option>
                                                        <option value="1">{t("Title_tr")}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="podcastbox">
                                        {podcastData?.map((data: any, i: number) => {
                                            const isTodaySatsang = i === 0;
                                            return (
                                                <div key={`data-${data.id}`}>
                                                    <div className="sidebarmargin">
                                                        <div
                                                            className="pravchanBox"

                                                            style={{
                                                                display: "flex",
                                                                padding: isTodaySatsang ? "28px 20px 15px 20px" : "15px 20px",
                                                                cursor: "pointer",
                                                                position: "relative",

                                                                background: isTodaySatsang
                                                                    ? "linear-gradient(135deg,#fff9e8 0%,#fff4d6 100%)"
                                                                    : "#fff",

                                                                border: isTodaySatsang
                                                                    ? "2px solid #f0b429"
                                                                    : "1px solid #f0c36d",

                                                                borderRadius: "16px",

                                                                boxShadow: isTodaySatsang
                                                                    ? "0 8px 25px rgba(240,180,41,0.18)"
                                                                    : "none",

                                                                overflow: "visible",
                                                            }}
                                                        >
                                                            {isTodaySatsang && (
                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-14px",
                                                                        left: "20px",
                                                                        background:
                                                                            "linear-gradient(90deg,#d97706,#f59e0b)",
                                                                        color: "#fff",
                                                                        padding: "4px 14px",
                                                                        borderRadius: "50px",
                                                                        fontSize: "14px",
                                                                        fontWeight: 700,
                                                                        zIndex: 2,
                                                                        boxShadow: "0 4px 12px rgba(217,119,6,.3)",
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    <StarIcon style={{ fontSize: "16px", verticalAlign: "middle", marginRight: "4px" }} /> {t("Today's_dailysatsang_tr")}
                                                                </div>
                                                            )}
                                                            <div style={{ marginRight: "25px" }}>
                                                                <a>
                                                                    <img
                                                                        className="audioicon"
                                                                        src={
                                                                            data.lyricsHash != null
                                                                                ? WithLyrics
                                                                                : WithoutLyrics
                                                                        }
                                                                        onError={(e) => {
                                                                            e.currentTarget.src = WithoutLyrics;
                                                                        }}
                                                                        alt={data.name}
                                                                        title={data.name}
                                                                        onClick={() => {
                                                                            // Play/open without login; download still requires UserIdentity
                                                                            localStorage.setItem("type", "DailySatsang")
                                                                            const slugToUse = data?.slug || data?.description || "";
                                                                            console.log("slugToUse", slugToUse);
                                                                            navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                                state: {
                                                                                    audioId: data?.id,
                                                                                    audioslug: slugToUse,
                                                                                    index: i,
                                                                                    pageNum: pagination.pageNo,
                                                                                },
                                                                            });
                                                                        }}
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    width: "100%",
                                                                    marginTop: isTodaySatsang ? "25px" : "0",
                                                                }}
                                                            >
                                                                <a
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        // Play/open without login; download still requires UserIdentity
                                                                        const slugToUse = data?.slug || data?.description || "";

                                                                        console.log("slug", data?.slug);
                                                                        console.log("description", data?.description);

                                                                        localStorage.setItem("type", "DailySatsang")
                                                                        navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                            state: {
                                                                                audioId: data?.id,
                                                                                audioslug: slugToUse,
                                                                                index: i,
                                                                                pageNum: pagination.pageNo,
                                                                            },
                                                                        });
                                                                    }}
                                                                >
                                                                    <p
                                                                        style={{
                                                                            fontSize: "25px",
                                                                            paddingTop: "3px",
                                                                            fontWeight: "600",
                                                                            textAlign: "unset",
                                                                        }}
                                                                    >
                                                                        <p style={{ fontSize: "22px", fontWeight: 600 }}>
                                                                            {data?.name}
                                                                            {isTodaySatsang && (
                                                                                <span
                                                                                    style={{
                                                                                        marginLeft: "10px",
                                                                                        background: "#f59e0b",
                                                                                        color: "#fff",
                                                                                        padding: "4px 10px",
                                                                                        borderRadius: "20px",
                                                                                        fontSize: "15px",
                                                                                        fontWeight: 700,
                                                                                        verticalAlign: "middle",
                                                                                    }}
                                                                                >
                                                                                    {t("New_tr")}
                                                                                </span>
                                                                            )}
                                                                        </p>


                                                                    </p>
                                                                    <div style={{ display: "grid" }}>
                                                                        <label>{data.description}</label>
                                                                        <label>{data.audioLength}</label>
                                                                    </div>
                                                                </a>


                                                            </div>

                                                            <div className="btns">
                                                                <div className="buttonres">
                                                                    <a
                                                                        id="download"
                                                                        title="Download"
                                                                        onClick={() => {
                                                                            if (UserIdentity) {
                                                                                downloadDailySatsang(data.audioPath != null
                                                                                    ? data.audioPath + "?t=" + encoded + "&download_attachment=true"
                                                                                    : "no record found")
                                                                            } else {
                                                                                setLogIn(true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt="download"
                                                                            src={imgdownload}
                                                                            className="downloadbtn"
                                                                        ></img>
                                                                    </a>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        paddingLeft: "5px",
                                                                    }}
                                                                >
                                                                    <img
                                                                        alt=""
                                                                        onClick={() => {
                                                                            // Play/open without login; download still requires UserIdentity
                                                                            localStorage.setItem("type", "DailySatsang")
                                                                            const slugToUse = data?.slug || data?.description || "";
                                                                            console.log("slugToUse", slugToUse);
                                                                            navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                                state: {
                                                                                    audioId: data.id,
                                                                                    audioslug: slugToUse,
                                                                                    index: i,
                                                                                    pageNum: pagination.pageNo,
                                                                                },
                                                                            });
                                                                        }}
                                                                        title="Play"
                                                                        src={imgpause}
                                                                        className="playbtn"
                                                                    ></img>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        )}

                                        <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                                            <ListPagination
                                                totalRecords={pagination.totalRecords}
                                                recordsPerPage={pagination.recordsPerPage}
                                                currentPage={pagination.pageNo}
                                                onClick={(p) => {
                                                    setPagination({
                                                        ...pagination,
                                                        pageNo: p,
                                                    });
                                                    setRefresh(true);
                                                }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        :
                        <div className="ebooks-category resultnotfound">
                            {loading && <Loader loading={loading} />}
                            {t("result_not_found_tr")}
                        </div>
                    }
                </div>
                <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
            </div>
        </div>
        </LocalizationProvider>
    )
}
export default DailySatsangPage;